import React, { useState, useEffect } from "react";
import {
  ContenedorFiltros,
  Formulario,
  Input,
  InputGrande,
  ContenedorBoton
} from "./../elementos/ElementosDeFormulario";
import Boton from "./../elementos/Boton";
import { ReactComponent as IconoPlus } from "./../imagenes/plus.svg";
import SelectCategorias from "./SelectCategorias";
import DatePicker from "./DatePicker";
//https://date-fns.org/v2.21.1/docs/fromUnixTime
//https://date-fns.org/v2.21.1/docs/getUnixTime
import fromUnixTime from "date-fns/fromUnixTime";
import getUnixTime from "date-fns/getUnixTime";
//firebase agregarGasto
import agregarGasto from "./../firebase/agregarGasto";
//extraer el usuario logeado
import { useAuth } from "./../contextos/AuthContext";
//alertas
import Alerta from "./../elementos/Alerta";
//useHistory
import { useHistory } from "react-router-dom";
//funcion para editar gasto
import editarGasto from "./../firebase/editarGasto";

const FormularioGasto = ({ gasto }) => {
  const [inputDescripcion, cambiarInputDescripcion] = useState("");
  const [inputCantidad, cambiarInputCantidad] = useState("");
  //input selectcategorias
  const [categoria, cambiarCategoria] = useState("hogar");
  //input datepicker
  const [fecha, cambiarFecha] = useState(new Date());
  //alertas
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});
  //contextos/AuthContext - useAuth()
  const { usuario } = useAuth();
  //useHistory()
  const history = useHistory();

  //editar gasto
  useEffect(() => {
    // Comprobamos si ya hay algun gasto.
    // De ser asi establecemos todo el state con los valores del gasto.
    if (gasto) {
      // Comprobamos que el gasto sea del usuario actual.
      // Para eso comprobamos el uid guardado en el gasto con el uid del usuario.
      if (gasto.data().uidUsuario === usuario.uid) {
        //console.log(gasto.data());
        cambiarCategoria(gasto.data().categoria);
        cambiarFecha(fromUnixTime(gasto.data().fecha));
        cambiarInputDescripcion(gasto.data().descripcion);
        cambiarInputCantidad(gasto.data().cantidad);
      } else {
        history.push("/lista");
      }
    }
  }, [gasto, usuario, history]);

  const handleChange = e => {
    if (e.target.name === "descripcion") {
      cambiarInputDescripcion(e.target.value);
    } else if (e.target.name === "cantidad") {
      cambiarInputCantidad(e.target.value.replace(/[^0-9.]/g, ""));
    }
  };

  //console.log(fecha);

  const handleSubmit = e => {
    e.preventDefault();
    //console.log(inputDescripcion, inputCantidad, categoria, fecha);
    let cantidad = parseFloat(inputCantidad).toFixed(2);
    //console.log(getUnixTime(fecha));
    //console.log(usuario.uid);
    if (inputDescripcion !== "" && inputCantidad !== "") {
      //comprobacion adicional
      if (cantidad) {
        //editar gasto
        if (gasto) {
          //console.log(gasto.id);
          editarGasto({
            id: gasto.id,
            categoria: categoria,
            descripcion: inputDescripcion,
            cantidad: cantidad,
            fecha: getUnixTime(fecha)
          })
            .then(() => {
              history.push("/lista");
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          agregarGasto({
            categoria: categoria,
            descripcion: inputDescripcion,
            cantidad: cantidad,
            fecha: getUnixTime(fecha),
            uidUsuario: usuario.uid
          })
            .then(() => {
              cambiarCategoria("hogar");
              cambiarInputDescripcion("");
              cambiarInputCantidad("");
              cambiarFecha(new Date());

              cambiarEstadoAlerta(true);
              cambiarAlerta({
                tipo: "exito",
                mensaje: "Ingresaste tu gasto de forma correcta"
              });
            })
            .catch(error => {
              cambiarEstadoAlerta(true);
              cambiarAlerta({
                tipo: "error",
                mensaje: "Hubo un problema al agregar el gasto"
              });
            });
        }
      } else {
        cambiarEstadoAlerta(true);
        cambiarAlerta({
          tipo: "error",
          mensaje: "El valor ingresado no es correcto"
        });
      }
    } else {
      //console.log('Agrega todos los valores');
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Rellena los campos requeridos"
      });
    }
  };

  return (
    <Formulario onSubmit={handleSubmit}>
      <ContenedorFiltros>
        <SelectCategorias
          categoria={categoria}
          cambiarCategoria={cambiarCategoria}
        />
        <DatePicker fecha={fecha} cambiarFecha={cambiarFecha} />
      </ContenedorFiltros>

      <div>
        <Input
          type="text"
          name="descripcion"
          id="descripcion"
          placeholder="Descripcion"
          value={inputDescripcion}
          onChange={handleChange}
        />
        <InputGrande
          type="text"
          name="cantidad"
          id="cantidad"
          placeholder="0.00€"
          value={inputCantidad}
          onChange={handleChange}
        />
      </div>

      <ContenedorBoton>
        <Boton as="button" primario conIcono type="submit">
          {gasto ? "Editar gasto" : "Agregar Gasto"}
          <IconoPlus />
        </Boton>
      </ContenedorBoton>
      <Alerta
        tipo={alerta.tipo}
        mensaje={alerta.mensaje}
        estadoAlerta={estadoAlerta}
        cambiarEstadoAlerta={cambiarEstadoAlerta}
      />
    </Formulario>
  );
};

export default FormularioGasto;
